import React from "react";
import "./TherapyProgress.css";
import { BiwazeColorEnum, BiwazeEnum } from "../../utils/constants";
import { IonIcon } from "@ionic/react";
import { checkmark, checkmarkDone, ticketSharp } from "ionicons/icons";

interface TherapyProgressProps {
  progress: number;
  deviceName?: string; // 0 to 100
  innerValue?: string;
  outerValue?: string;
  isComplete?: boolean;
}

const TherapyProgress: React.FC<TherapyProgressProps> = ({
  progress,
  deviceName,
  isComplete,
  innerValue,
  outerValue,
}) => {
  const radius = 18;
  const strokeColor =
    deviceName === BiwazeEnum.COUGH
      ? BiwazeColorEnum.COUGH
      : BiwazeColorEnum.CLEAR; // Color of the circle stroke
  const circumference = 2 * Math.PI * radius;
  const dashArray = "2 2";
  const progressOffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className="progress-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      {!isComplete && (
        <svg
          width="60"
          height="60"
          viewBox="0 0 40 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="18"
            stroke={strokeColor}
            strokeWidth="4"
            strokeDasharray="2 2"
          />
        </svg>
      )}
      {isComplete && (
        <div className="max-w-[60px] max-h-[50px] flex justify-center items-center">
          <svg
            width="60"
            height="50"
            viewBox="0 0 40 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="20"
              cy="20"
              r="18"
              stroke={strokeColor}
              strokeWidth="4"
              strokeDashoffset={progressOffset}
              fill={isComplete ? strokeColor : "none"}
            />

            {deviceName === BiwazeEnum.COUGH ? (
              <foreignObject x="7" y="7" width="26" height="26">
                <svg
                  width="70%"
                  height="70%"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: "block", margin: "auto", marginTop: "4px" }}
                >
                  <path
                    d="M5.91406 13.9539C5.41406 13.9539 5.03906 13.7742 4.70312 13.3757L0.671875 8.49292C0.390625 8.17261 0.289062 7.88354 0.289062 7.55542C0.289062 6.82104 0.835938 6.28198 1.59375 6.28198C2.03125 6.28198 2.34375 6.43823 2.63281 6.78198L5.875 10.8054L12.2656 0.727295C12.5781 0.235107 12.8984 0.0476074 13.4141 0.0476074C14.1641 0.0476074 14.7109 0.578857 14.7109 1.31323C14.7109 1.58667 14.625 1.87573 14.4219 2.18823L7.14062 13.321C6.85938 13.7507 6.44531 13.9539 5.91406 13.9539Z"
                    fill="black"
                  />
                </svg>
              </foreignObject>
            ) : (
              <text
                x="50%"
                y="20"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize="16"
                fontWeight="700"
                fontFamily="Figtree"
                letterSpacing="0.35px"
                fill={"#000000"}
                style={{
                  lineHeight: "20px",
                }}
              >
                {innerValue}
              </text>
            )}
          </svg>
        </div>
      )}
      {/* text below the circle  */}
      <div className="progress-text">
        {/* need to add the therapy completion value based on the time of completion with the time stamp */}
        {isComplete ? outerValue?.trim() : " "}  
      </div>
    </div>
  );
};

export default TherapyProgress;
